const ShopifyWatch = {
    watchCart: (cartObj, component) => {
        (function(ns, fetch) {
            if (typeof fetch !== 'function') return;
            ns.fetch = function() {
            const response = fetch.apply(this, arguments);

            response.then(res => {
                if ([
                        `${window.location.origin}/cart/update`,
                        `${window.location.origin}/cart/change`,
                        `${window.location.origin}/cart/clear`,
                    ].includes(res.url)) {
                    if (res.status === 200) {
                        res.clone().json().then(data => {
                        // Merge new cart data with original cart obj
                        if (cartObj) {
                            const newCart = Object.assign(cartObj, data);
                            cartObj = newCart;
                            if (component) {
                                component.$forceUpdate();
                            }
                        }
                        });
                    }
                } else if ([`${window.location.origin}/cart/add`].includes(res.url)) {
                    const newCart = cartObj;
                    if (res.status === 200) {
                    res.clone().json().then(data => {
                        if (cartObj) {
                            // If cart is empty add item
                            if (newCart.items.length === 0) {
                            newCart.items.push(data);
                            newCart.item_count = data.quantity;
                            newCart.total_price += data.price * data.quantity;
                            } else {
                            let total;
                            let quantity;
                            newCart.items.forEach(item => {
                                // If item exists in cart update quantity
                                if (item.id === data.id) {
                                const netQuantity = data.quantity - item.quantity;
                                quantity = netQuantity;
                                total = item.price * netQuantity;
                                item.quantity = data.quantity;
                                } else {
                                // Add new item to items array
                                quantity = data.quantity;
                                newCart.items.push(data);
                                total = data.price * data.quantity;
                                }
                                newCart.total_price += total;
                                newCart.item_count = quantity;
                            });
                            
                            }
                            // Update Cart Object and Component
                            cartObj = newCart;
                            if (component) {
                                component.$forceUpdate();
                            }
                        }
                    });
                    }
                }
            });

            return response;
            }
        }(window, window.fetch))
    }
}
